// src/Pages/TrabalheConosco.js
import React from 'react';
import Button from '../Components/Button';
import Layout from '../Components/Layout/Layout';
function TrabalheConosco() {
  return (
    <Layout>
        <div className='page'>
            <h1>Trabalhe Conosco</h1>
        </div>
    </Layout>
  );
}

export default TrabalheConosco;

